<div class="widget-header flex flex-row place-content-between items-center mb-5">
  <h1 class="text-2xl font-medium">
    <ng-container *ngIf="isOtherUser; else yourPersonalInfo" i18n>Personal information</ng-container>
    <ng-template #yourPersonalInfo i18n>Your personal information</ng-template>
  </h1>
  <button *ngIf="!editMode && (!isOtherUser || (AnyUserProfile | can : 'info.update'))" mat-icon-button i18n-matTooltip matTooltip="Edit personal information" (click)="onPersonalInfoEdit(true)">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
  </button>
  <div *ngIf="editMode" class="whitespace-nowrap user-actions">
    <button mat-icon-button [disabled]="!userEditGroup.valid" i18n-matTooltip matTooltip="Save" class="save-button" (click)="onPersonalInfoEdit(false)">
      <mat-icon class="material-icons-outlined">save</mat-icon>
    </button>
    <button mat-icon-button i18n-matTooltip matTooltip="Close" (click)="onPersonalInfoEdit(false, 'close')">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>
  </div>
</div>
<form [formGroup]="userEditGroup" class="user-form-field" (ngSubmit)="onPersonalInfoEdit(false)">
  <!-- First Name -->
  <div class="field-control">
    <div class="field-label" i18n>First Name</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="First Name" i18n-placeholder formControlName="userEdit_first_name" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_first_name'].errors?.['required']" i18n>First Name is required</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_first_name'].errors?.['minlength']" i18n>Minimum 2 characters</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_first_name'].errors?.['invalidName']" i18n>Invalid character in first name</mat-error>
    </mat-form-field>
  </div>
  <!-- Last Name -->
  <div class="field-control">
    <div class="field-label" i18n>Last Name</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Last Name" i18n-placeholder formControlName="userEdit_last_name" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_last_name'].errors?.['required']" i18n>Last Name is required</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_last_name'].errors?.['minlength']" i18n>Minimum 2 characters</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_last_name'].errors?.['invalidName']" i18n>Invalid character in last name</mat-error>
    </mat-form-field>
  </div>
  <!-- Position -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Position</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Position" i18n-placeholder formControlName="userEdit_position" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_position'].errors?.['minlength']" i18n>Minimum 2 characters</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_position'].errors?.['invalidName']" i18n>Invalid character in position</mat-error>
    </mat-form-field>
  </div>
  <!-- Agency -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Agency</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Agency" i18n-placeholder formControlName="userEdit_agency" readonly />
      <mat-error *ngIf="userEditGroup.controls['userEdit_agency'].errors?.['minlength']" i18n>Minimum 2 characters</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_agency'].errors?.['invalidName']" i18n>Invalid character in agency</mat-error>
    </mat-form-field>
  </div>
  <!-- Location -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Location</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Location" i18n-placeholder formControlName="userEdit_location" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_location'].errors?.['minlength']" i18n>Minimum 2 characters</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_location'].errors?.['invalidName']" i18n>Invalid character in location</mat-error>
    </mat-form-field>
  </div>
  <!-- Language -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Language</div>
    <sp-mat-select-search
      class="w-full"
      formControlName="userEdit_language"
      [dataSource]="languages"
      [placeholder]="'-Select language-'"
      [config]="{ search: true, titleCase: true }"
      [disabledField]="userEditGroup.disabled"
      [attrDataTestId]="'user-personal-information_language'"
    ></sp-mat-select-search>
  </div>
  <!-- E-mail -->
  <div class="field-control">
    <div class="field-label" i18n>E-mail</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="email" placeholder="E-mail" i18n-placeholder formControlName="userEdit_email" [disabled]="true" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_email'].errors?.['required']" i18n>Email is required</mat-error>
      <mat-error *ngIf="userEditGroup.controls['userEdit_email'].errors?.['email'] || userEditGroup.controls['userEdit_email'].errors?.['pattern']" i18n>Invalid email</mat-error>
    </mat-form-field>
  </div>
  <!-- Username -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Username</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Username" i18n-placeholder formControlName="userEdit_username" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_username'].errors?.['required']" i18n>Username is required</mat-error>
    </mat-form-field>
  </div>
  <!-- Phone -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Phone</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Phone" i18n-placeholder formControlName="userEdit_phone" (keypress)="allowNumbersOnly($event)" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_phone'].errors?.['minlength']" i18n>Minimum 5 characters</mat-error>
    </mat-form-field>
  </div>
  <!-- Mobile -->
  <div class="field-control" *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey)">
    <div class="field-label" i18n>Mobile</div>
    <mat-form-field appearance="outline" floatLabel="auto">
      <input matInput type="text" placeholder="Mobile" i18n-placeholder formControlName="userEdit_phone_mobile" (keypress)="allowNumbersOnly($event)" />
      <mat-error *ngIf="userEditGroup.controls['userEdit_phone_mobile'].errors?.['minlength']" i18n>Minimum 10 characters</mat-error>
    </mat-form-field>
  </div>
  <!-- Click me -->
  <div
    *ngIf="![CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge, CustomClients.Vorwerk].includes(brandingKey) && isOtherUser"
    class="flex flex-row text-sm items-baseline mt-3"
  >
    <div class="field-label" i18n>Chat with me</div>
    <div class="flex flex-col w-9/12">
      <a href="{{ 'http://teams.microsoft.com/l/chat/0/0?users=' + loggedInUserEmail }}" target="blank" class="flex items-center text-blue-700">
        <mat-icon aria-hidden="false" svgIcon="msteams"></mat-icon>
        <ng-container i18n>Chat with me</ng-container>
      </a>
    </div>
  </div>
</form>
